import React from 'react';
import { TextLink, Typography } from '@guildeducationinc/recess';
import { ResetFiltersAnchor } from 'src/components/ResetFiltersAnchor';
import { BENEFITS_URL } from 'src/utilities/envConfig';
import { NoResultsIcon } from '@src/components/NoResultsPlaceholder/NoResultsIcon';
import { useDecision } from '@optimizely/react-sdk';
import { ONE_FRONT_DOOR } from '@src/constants/featureFlags';
import { OneFrontDoorNoResultsPlaceholder } from './OneFrontDoorNoResultsPlaceholder';
import styles from './NoResultsPlaceholder.module.scss';

export const NoResultsPlaceholder: React.FC = () => {
	const [oneFrontDoorDecision] = useDecision(ONE_FRONT_DOOR);
	if (oneFrontDoorDecision?.enabled === true) {
		return <OneFrontDoorNoResultsPlaceholder />;
	}
	return (
		<div className={styles.noResults} data-testid='search-placeholder'>
			<NoResultsIcon />
			<Typography className={styles.header} variant='h3'>
				We can&apos;t find any programs that match your search
			</Typography>
			<Typography className={styles.spacing} variant='body2'>
				But don&apos;t give up just yet.
			</Typography>
			<Typography className={styles.spacing} data-testid='clear-your-filters' variant='body1'>
				<ResetFiltersAnchor ctaCopy='Clear your filters' /> and search again
			</Typography>
			<Typography className={styles.spacing} variant='body1'>
				Explore your{' '}
				<TextLink data-testid='benefit-xoptions' href={BENEFITS_URL} target='_blank'>
					benefit options
				</TextLink>
			</Typography>
		</div>
	);
};
